import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

/**
 * Customer Google OAuth callback (public site).
 * Emergent lands us here with `#session_id=<uuid>` in the URL fragment.
 * We POST it to /api/public/customers/google-callback which sets the customer_token cookie.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function PublicAuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      toast.error("Sign-in session was missing");
      nav("/site/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await api.post("/public/customers/google-callback", {
          session_id: sessionId, tenant_slug: "abrah",
        });
        // Clear the fragment so the token isn't retained in browser history
        window.history.replaceState({}, "", loc.pathname);
        toast.success("Signed in with Google");
        nav("/site/account", { replace: true });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Google sign-in failed");
        nav("/site/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <Loader2 size={28} className="animate-spin text-emerald-700 mx-auto" />
        <div className="mt-3 text-sm text-gray-600">Finishing Google sign-in…</div>
      </div>
    </div>
  );
}
